<div class="d-flex gap-2 flex-wrap align-items-center">
    <!-- Filter dropdown -->
    <div class="dropdown">
        <button type="button" [id]="filterDropdownId" class="btn btn-ms-secondary dropdown-toggle"
            data-bs-auto-close="outside" data-bs-toggle="dropdown" aria-expanded="false">
            <fa-duotone-icon icon="filter" secondaryOpacity="0.6" class="fs-6 d-none d-sm-inline me-2" />
            <span class="filter-label-text">{{ filterLabel() }}</span>
            @if (filterCount() > 0) {
                <span class="position-absolute top-0 start-0 translate-middle badge border rounded-circle filter-count">{{ filterCount() }}</span>
            }
        </button>

        <div ms-parent-focus [alwaysFocusOnRemoval]="true" class="dropdown-menu document-filter-menu" (keyup.control.enter)="onApply()">

            <div class="fs-5 fw-bold px-3 py-2">Filter Options</div>

            <div class="separator border-gray-200"></div>

            @if (canFilterByAccess()) {
                <div class="mb-2 px-3 py-2">
                    <label class="form-label fw-semibold">Access:</label>
                    <ms-multi-select placeholder="Select Access" [options]="permissionOptions"
                        [selectedOptions]="selectedPermissions()" (selectionChange)="onPermissionsChange($event)" />
                </div>
            }

            @if (canFilterFiles()) {
                <div class="mb-2 px-3 py-2">
                    <label class="form-label fw-semibold">File type:</label>
                    <ms-multi-select placeholder="Select File Type" [options]="fileTypeOptions"
                        [selectedOptions]="selectedFileTypes()" (selectionChange)="onFileTypesChange($event)" />
                </div>

                <div class="mb-2 px-3 py-2 mw-100">
                    <label class="form-label fw-semibold">Modified date:</label>
                    <div class="row">
                        <div class="col-6">
                            <input type="date" class="form-control form-control-solid"
                                [ngModel]="draftModifiedAfter()" (ngModelChange)="draftModifiedAfter.set($event)" />
                        </div>
                        <div class="col-6">
                            <input type="date" class="form-control form-control-solid"
                                [ngModel]="draftModifiedBefore()" (ngModelChange)="draftModifiedBefore.set($event)" />
                        </div>
                    </div>
                </div>
            }

            <div class="d-flex justify-content-end px-3 py-2">
                <button type="reset" class="btn btn-ms-secondary reset-filter-button me-2 px-6"
                    (click)="onReset()">Reset</button>
                <button type="submit" class="btn btn-primary px-6" (click)="onApply()">Apply</button>
            </div>
        </div>
    </div>

    <ms-sort-dropdown
        [sortOptions]="sortOptions()"
        [selectedSortOption]="sort()"
        (selectedSortOptionChange)="onSortChanged($event)" />

    <input #fileInput type="file" multiple class="d-none" (change)="onFilesPicked($event)" aria-hidden="true" />

    <!-- Create/upload/bulk actions apply only while browsing a folder, not in search; and only for
         users who can perform at least one — members see no Actions button. -->
    @if (isBrowse()) {
    <div class="dropdown"
        *ifHasPermission="{ requiredPermissions: [DocumentsPermission.Upload, DocumentsPermission.Manage, DocumentsPermission.ManagePermissions], userPermissionOnly: false }">
        <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown">
            Actions
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
            @if (canUpload()) {
                <li *ifHasPermission="{ requiredPermissions: [DocumentsPermission.Upload], userPermissionOnly: false }">
                    <button type="button" class="dropdown-item" (click)="openFilePicker()">
                        <fa-duotone-icon icon="arrow-up-from-bracket" secondaryOpacity="0.4" class="me-2" />
                        Upload files
                        <span class="d-block small text-secondary ms-4 ps-1">{{ maxFileSizeHint }}</span>
                    </button>
                </li>
            }
            <li *ifHasPermission="{ requiredPermissions: [DocumentsPermission.Manage], userPermissionOnly: false }">
                <button type="button" class="dropdown-item" (click)="requestNewFolder()">
                    <fa-duotone-icon icon="folder-plus" secondaryOpacity="0.4" class="me-2" />
                    New folder
                </button>
            </li>
            @if (moveEligibleCount() > 0 || permissionEligibleCount() > 0 || deleteFolderEligibleCount() > 0 || deleteFileEligibleCount() > 0) {
                <li><hr class="dropdown-divider" /></li>
            }
            @if (moveEligibleCount() > 0) {
                <li *ifHasPermission="{ requiredPermissions: [DocumentsPermission.Manage], userPermissionOnly: false }">
                    <button type="button" class="dropdown-item" (click)="requestBulkMove()">
                        <fa-duotone-icon icon="folder-tree" secondaryOpacity="0.4" class="me-2" />
                        Move to… ({{ moveEligibleCount() }})
                    </button>
                </li>
            }
            @if (permissionEligibleCount() > 0) {
                <li *ifHasPermission="{ requiredPermissions: [DocumentsPermission.ManagePermissions], userPermissionOnly: false }">
                    <button type="button" class="dropdown-item" (click)="requestBulkPermissions()">
                        <fa-duotone-icon icon="lock" secondaryOpacity="0.4" class="me-2" />
                        Change permissions ({{ permissionEligibleCount() }})
                    </button>
                </li>
            }
            @if (deleteFolderEligibleCount() > 0) {
                <li *ifHasPermission="{ requiredPermissions: [DocumentsPermission.Manage], userPermissionOnly: false }">
                    <button type="button" class="dropdown-item text-danger" (click)="requestBulkDeleteFolders()">
                        <fa-duotone-icon icon="trash" secondaryOpacity="0.4" class="me-2" />
                        Delete folders ({{ deleteFolderEligibleCount() }})
                    </button>
                </li>
            }
            @if (deleteFileEligibleCount() > 0) {
                <li *ifHasPermission="{ requiredPermissions: [DocumentsPermission.Manage], userPermissionOnly: false }">
                    <button type="button" class="dropdown-item text-danger" (click)="requestBulkDeleteFiles()">
                        <fa-duotone-icon icon="trash" secondaryOpacity="0.4" class="me-2" />
                        Delete files ({{ deleteFileEligibleCount() }})
                    </button>
                </li>
            }
        </ul>
    </div>
    }
</div>
